import { render, staticRenderFns } from "./VSnackBar.vue?vue&type=template&id=9e5bc71e"
import script from "./VSnackBar.vue?vue&type=script&lang=js"
export * from "./VSnackBar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports